module.exports = __webpack_public_path__ + "img/octopus.be5030ca.webp";